import React from 'react';
const SvgPptThumbnail = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 96 96" width="1em" height="1em" {...props}>
      <path fill="#FFF" d="M86 88H26V8h42l18 18z" />
      <path fill="#F5BA9D" d="M58 20c8.837 0 16 7.163 16 16H58V20z" />
      <path fill="#949494" d="M68.001 6H24v84h64V26L68.001 6zM68 9l17 17H68V9zm18 79H26V8h40v20h20v60z" />
      <path
        fill="#C8C8C8"
        d="M74 38c0 9.941-8.059 18-18 18s-18-8.059-18-18 8.059-18 18-18v18h18zM48 70h32v2H48zM48 64h32v2H48zM48 76h32v2H48z"
      />
      <path fill="#B7472A" d="M8 34l40-6v52L8 74z" />
      <path
        fill="#FFF"
        d="M24.931 58.077V66H20V43h7.725C33.241 43 36 45.444 36 50.33c0 2.31-.791 4.178-2.374 5.605-1.583 1.428-3.697 2.142-6.343 2.142H24.93zm0-11.1v7.17h1.94c2.625 0 3.938-1.208 3.938-3.625 0-2.363-1.313-3.544-3.939-3.544h-1.939zM68 10v16h16L68 10"
      />
      <linearGradient
        id="ppt-thumbnail_svg__a"
        gradientUnits="userSpaceOnUse"
        x1={17.173}
        y1={11.728}
        x2={84.979}
        y2={92.535}
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.226} stopColor="#fcfcfc" stopOpacity={0.023} />
        <stop offset={0.363} stopColor="#f4f4f4" stopOpacity={0.036} />
        <stop offset={0.475} stopColor="#e6e6e6" stopOpacity={0.048} />
        <stop offset={0.574} stopColor="#d1d1d1" stopOpacity={0.057} />
        <stop offset={0.665} stopColor="#b7b7b7" stopOpacity={0.067} />
        <stop offset={0.75} stopColor="#979797" stopOpacity={0.075} />
        <stop offset={0.83} stopColor="#707070" stopOpacity={0.083} />
        <stop offset={0.906} stopColor="#444" stopOpacity={0.091} />
        <stop offset={0.976} stopColor="#121212" stopOpacity={0.098} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#ppt-thumbnail_svg__a)" d="M88 26L68 6H24v84h64V26z" />
      <linearGradient id="ppt-thumbnail_svg__b" gradientUnits="userSpaceOnUse" x1={76} y1={33.813} x2={76} y2={28.175}>
        <stop offset={0} stopColor="#828282" stopOpacity={0} />
        <stop offset={0.281} stopColor="#7f7f7f" stopOpacity={0.028} />
        <stop offset={0.45} stopColor="#777" stopOpacity={0.045} />
        <stop offset={0.59} stopColor="#696969" stopOpacity={0.059} />
        <stop offset={0.713} stopColor="#545454" stopOpacity={0.071} />
        <stop offset={0.826} stopColor="#3a3a3a" stopOpacity={0.083} />
        <stop offset={0.929} stopColor="#1a1a1a" stopOpacity={0.093} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#ppt-thumbnail_svg__b)" d="M66 28h20v6H66z" />
      <linearGradient
        id="ppt-thumbnail_svg__c"
        gradientUnits="userSpaceOnUse"
        x1={62.54}
        y1={24.46}
        x2={74.472}
        y2={12.528}
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.854} stopColor="#fff" stopOpacity={0.213} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.25} />
      </linearGradient>
      <path fill="url(#ppt-thumbnail_svg__c)" d="M24 6v2h42v20h20v28h2V26L68 6z" />
      <linearGradient
        id="ppt-thumbnail_svg__d"
        gradientUnits="userSpaceOnUse"
        x1={35.508}
        y1={85.837}
        x2={36.355}
        y2={77.86}
      >
        <stop offset={0} stopColor="#828282" stopOpacity={0} />
        <stop offset={0.17} stopColor="#7e7e7e" stopOpacity={0.034} />
        <stop offset={0.346} stopColor="#717171" stopOpacity={0.069} />
        <stop offset={0.525} stopColor="#5d5d5d" stopOpacity={0.105} />
        <stop offset={0.706} stopColor="#404040" stopOpacity={0.141} />
        <stop offset={0.886} stopColor="#1b1b1b" stopOpacity={0.178} />
        <stop offset={0.997} stopOpacity={0.2} />
      </linearGradient>
      <path fill="url(#ppt-thumbnail_svg__d)" d="M48 86H24v-9.6L48 80z" />
      <linearGradient id="ppt-thumbnail_svg__e" gradientUnits="userSpaceOnUse" x1={28} y1={78.375} x2={28} y2={29.517}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.859} stopColor="#fff" stopOpacity={0.155} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.18} />
      </linearGradient>
      <path fill="url(#ppt-thumbnail_svg__e)" d="M48 28L8 34v40l40 6z" />
    </svg>
  );
});
export default SvgPptThumbnail;
SvgPptThumbnail.iconName = 'ppt-thumbnail';
SvgPptThumbnail.displayName = 'SvgPptThumbnail';
